<template>
  <div class="wxReg">
    <LoginBg>
      <div class="login-content">
        <img src="@/assets/img/login/title.png" alt="logo" />
        <div class="login-form">
          <div class="tabs">
            <div class="tabItem pointer tabActive">微信登录</div>
          </div>
          <div class="wxLogin">
            <el-form
              :model="fastDataForm"
              :rules="dataRule1"
              ref="fastDataForm"
              @keyup.enter.native="fastDataFormSubmitHandle()"
            >
              <div class="topTip">
                应《中华人民共和国网络安全法》要求，烦请您绑定手机号。
              </div>
              <el-form-item prop="fastPhone">
                <el-input
                  v-model="fastDataForm.fastPhone"
                  :placeholder="$t('login.accountPlaceholder')"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item prop="imgfastCaptcha">
                <div class="relative">
                  <el-input
                    v-model="fastDataForm.imgfastCaptcha"
                    :placeholder="$t('login.captchaPlaceholder')"
                    maxlength="20"
                  ></el-input>
                  <img
                    class="captchaImg"
                    @click="getCaptcha"
                    :src="captchaPath"
                    :disabled="disabled"
                  />
                </div>
              </el-form-item>
              <el-form-item prop="fastCaptcha">
                <div class="relative">
                  <el-input
                    v-model="fastDataForm.fastCaptcha"
                    :placeholder="$t('login.captchaPlaceholder')"
                    maxlength="20"
                  ></el-input>
                  <el-button
                    class="codeBtn"
                    type="text"
                    @click="sendcode"
                    :loading="loading"
                    :disabled="disabled"
                    >{{ btntxt }}</el-button
                  >
                </div>
              </el-form-item>
              <div class="center m-y-40">
                <div>
                  <el-button
                    class="submitBtn"
                    :class="{ disabledSubmitBtn: !agreeChecked }"
                    type="primary"
                    @click="fastDataFormSubmitHandle"
                    >注册 / 登录</el-button
                  >
                  <div class="submitTip">未注册手机号验证后自动注册登录</div>
                </div>
              </div>
              <div class="center">
                <el-checkbox v-model="agreeChecked" class="submitTip"
                  >阅读并同意以下协议<a @click.stop="visible = true">{{
                    $t("login.servicePolicy")
                  }}</a
                  ><a @click.stop="visiblePrivacy = true">{{
                    $t("login.userPrivacyPolicy")
                  }}</a></el-checkbox
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </LoginBg>
    <UserAgree v-if="visible" :visible="visible" @close="visible = false" />
    <PrivacyAgree
      v-if="visiblePrivacy"
      :visible="visiblePrivacy"
      @close="visiblePrivacy = false"
    />
    <!-- 账户重新激活确认 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span>检测到您在平台有已失效的账户，请确认是否重新激活。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$router.push({ name: 'main' })">放弃</el-button>
        <el-button type="primary" @click="activeAccount">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LoginBg from './login/components/bg.vue'
import { getUUID } from '@/utils'
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { isMobile } from '@/utils/validate'
import { getEnvConfig } from '@/utils/envConfig.js'
import { Base64 } from 'js-base64'

export default {
  components: {
    LoginBg
  },
  data () {
    return {
      visible: false,
      visiblePrivacy: false,
      centerDialogVisible: false,
      agreeChecked: false,
      dataForm: {
        username: '',
        password: '',
        grant_type: 'password',
        appCode: window.SITE_CONFIG.appCode,
        client_id: 'shopping',
        loginType: '0',
        env: getEnvConfig().env,
        domain: getEnvConfig().domain
      },
      fastDataForm: {
        fastPhone: '',
        fastCaptcha: '',
        requestId: ''
      },
      loading: false,
      disabled: false,
      time: 0,
      btntxt: this.$t('login.captchaGet'),
      captchaPath: '',
      routerForm: '',
      wxInfo: JSON.parse(sessionStorage.getItem('wxInfo') || '{}')
    }
  },
  computed: {
    dataRule1 () {
      let validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          return callback(
            new Error(
              this.$t('validate.format', { attr: this.$t('user.mobile') })
            )
          )
        }
        callback()
      }
      return {
        fastPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validateMobile, trigger: 'blur' }
        ],
        fastCaptcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    // 快捷手机验证码登录
    fastDataFormSubmitHandle: debounce(
      function () {
        if (!this.agreeChecked) {
          this.$confirm(
            '登录即代表您同意《Plantmate服务协议》与《用户隐私权政策》，继续登录吗?',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'none'
            }
          )
            .then(() => {
              this.agreeChecked = true
            })
            .catch(() => {})
          return
        }
        this.$refs['fastDataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.loading = true
          // 后台请求
          this.$http
            .post('/front/mall/v2/login', {
              // params: {
              requestId: this.fastDataForm.requestId,
              messageCode: this.fastDataForm.fastCaptcha,
              mobile: this.fastDataForm.fastPhone,
              openPlatformWebsiteAppOpenidCiphertext: this.wxInfo.openPlatformWebsiteAppOpenidCiphertext
              // }
            })
            .then(({ data: res }) => {
              if (res.code === 0 && typeof res.data === 'string') {
                this.$router.push({
                  name: 'login-registe',
                  query: {
                    mobile: Base64.encode(this.fastDataForm.fastPhone),
                    usernameForValidate: Base64.encode(res.data) // 增加返回参数，注册接口用
                  }
                })
              } else if (res.code === 0) {
                Cookies.set('access_token_shop', res.data.access_token)
                Cookies.set('username_shop', res.data.username)
                // 学习平台cookie登录共享
                Cookies.set('access_token_shop', res.data.access_token, {
                  domain: location.origin.includes('plantmate.supcon.com')
                    ? '.supcon.com'
                    : '.plantmate.com'
                })
                Cookies.set('username_shop', res.data.username, {
                  domain: location.origin.includes('plantmate.supcon.com')
                    ? '.supcon.com'
                    : '.plantmate.com'
                })
                this.bus.$emit('getUserMenuPerm')
                console.log(this.routerForm)
                const redirectUrl = this.toRedirectUrl()
                if (redirectUrl) {
                  setTimeout(() => {
                    window.location.href = redirectUrl
                  }, 300)
                  return
                }
                if (
                  this.routerForm.name === null ||
                  !this.routerForm.fullPath ||
                  this.routerForm.name === 'forget' ||
                  this.routerForm.name === 'login-registe'
                ) {
                  this.$router.replace({ name: 'home' })
                } else {
                  this.$router.push({
                    name: this.routerForm.name,
                    query: this.routerForm.query
                  })
                }
              } else if (res.code === 90001) {
                this.centerDialogVisible = true
              }
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
            .finally(() => {
              this.loading = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 重定向地址
    toRedirectUrl () {
      const redirectUrl = sessionStorage.getItem('redirectUrl')
      if (redirectUrl) {
        sessionStorage.removeItem('redirectUrl')
        // window.location.href = redirectUrl
      }
      return redirectUrl
    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/front/consumer/sysCaptcha/${this.dataForm.uuid}`
    },
    // 手机验证发送验证码
    sendcode () {
      // const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
      if (this.fastDataForm.fastPhone === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!isMobile(this.fastDataForm.fastPhone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else if (!this.fastDataForm.imgfastCaptcha) {
        this.$message({
          message: this.$t('forget.captchaPlaceholder'),
          type: 'warning'
        })
      } else {
        this.loading = true
        this.fastDataForm.requestId = ''
        this.disabled = true
        // 快捷登录发送验证码
        this.$http
          .get(
            `front/consumer/sendVerificationCodeByCaptcha?mobile=${this.fastDataForm.fastPhone}&uuid=${this.dataForm.uuid}&captcha=${this.fastDataForm.imgfastCaptcha}`
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.fastDataForm.requestId = res.data.requestId
              this.time = 60
              this.timer()
            } else {
              this.getCaptcha()
              this.disabled = false
            }
          })
          .catch(() => {
            this.disabled = false
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.disabled = true
        this.btntxt = this.time + 's' + this.$t('login.captchaGetAgain')
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = this.$t('login.captchaGet')
        this.disabled = false
        this.getCaptcha()
      }
    },
    // 已注销手机号重新激活
    activeAccount () {
      this.$store.commit('setLoadStatus', true)
      this.$http
        .post('/front/consumer/user/activated', {
          mobile: this.fastDataForm.fastPhone
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit('setLoadStatus', false)
            this.$message.success('激活成功,请重新登录')
            setTimeout(() => {
              window.location.reload()
            }, 600)
            this.centerDialogVisible = false
          }
        })
        .catch((err) => {
          this.$store.commit('setLoadStatus', false)
          this.$message.error(err.message)
        })
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.wxReg {
  .login-content {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .login-form {
    margin-top: 36px;
    width: 477px;
    // height: 526px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 16px;
    background: #fefefe;
    box-sizing: border-box;
    border: 1px solid #ffffff;
    padding: 16px;
  }
  .tabs {
    width: 100%;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tabItem {
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    text-align: center;
    color: #666666;
    padding: 0 20px 16px;
    position: relative;
    top: 4px;
  }
  .tabActive {
    box-sizing: border-box;
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: #2a54d1;
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    font-weight: bold;
    color: #2a54d1;
  }

  .wxLogin {
    padding: 24px;
  }
  .relative {
    position: relative;
  }
  .codeBtn {
    position: absolute;
    top: 6px;
    right: 28px;
  }
  .captchaImg {
    width: 100px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 12px;
  }
  .submitBtn {
    width: 183px;
    height: 43px;
    border-radius: 8px;
    background: #2a54d1;
    box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
    display: inline-block;
  }
  .disabledSubmitBtn {
    background-color: #74b7ff;
    opacity: 0.3;
  }
  .topTip {
    font-size: 12px;
    line-height: 18px;
    color: #666666;
    margin-bottom: 8px;
  }
  .submitTip {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 8px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #666666;
    }
    a {
      color: #2a54d1;
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .m-y-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2a54d1;
  }
  ::v-deep .el-button--text {
    color: #2a54d1;
  }
  ::v-deep .el-button--primary {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2a54d1;
  }
}
</style>
